export interface IExpertiseError {
  [key: string]: boolean
}

export const TAG_MARKERS = [
  {
    value: 0,
    label: 'Set level of expertise'
  },
  {
    value: 1,
    label: 'Interested'
  },
  {
    value: 2,
    label: 'Pursuing'
  },
  {
    value: 3,
    label: 'Accomplished'
  },
  {
    value: 4,
    label: 'Master'
  }
]

export interface IFlatExpertise {
  title: string
  tags: {
    [key: number]: {
      title: string
      level: number
    }
  }
}

export const imGoodAtInitialState = {
  becomeExpertInEditingIndex: -1,
  expertiseEditingIndex: -1,
  becomeExpertIn: {} as { [key: string]: string },
  expertise: {} as { [key: number]: IFlatExpertise },
  expertiseErrors: {} as IExpertiseError
}

export type ImGoodAtState = typeof imGoodAtInitialState
